import Icons from '../../../components/icons';
import { AdmissionType } from '../types';

export const newPaymentSchemeOptions = [
  {
    label: 'Full Year Fees',
    validFeePeriods: ['Full Payment']
  },
  {
    label: '8 Installments',
    validFeePeriods: [
      'Installment-1',
      'Installment-2',
      'Installment-3',
      'Installment-4',
      'Installment-5',
      'Installment-6',
      'Installment-7',
      'Installment-8'
    ]
  },
  {
    label: '7 Installments',
    validFeePeriods: [
      'Installment-1',
      'Installment-2',
      'Installment-3',
      'Installment-4',
      'Installment-5',
      'Installment-6',
      'Installment-7'
    ]
  },
  {
    label: '6 Installments',
    validFeePeriods: [
      'Installment-1',
      'Installment-2',
      'Installment-3',
      'Installment-4',
      'Installment-5',
      'Installment-6'
    ]
  },
  {
    label: '5 Installments',
    validFeePeriods: [
      'Installment-1',
      'Installment-2',
      'Installment-3',
      'Installment-4',
      'Installment-5'
    ]
  },
  {
    label: '4 Installments',
    validFeePeriods: [
      'Installment-1',
      'Installment-2',
      'Installment-3',
      'Installment-4'
    ]
  },
  {
    label: '3 Installments',
    validFeePeriods: ['Installment-1', 'Installment-2', 'Installment-3']
  },
  {
    label: '2 Installments',
    validFeePeriods: ['Installment-1', 'Installment-2']
  }
];

export const PaymentSchemeDetailTabs = [
  {
    id: 'installments',
    label: 'Installments'
  },
  {
    id: 'formF',
    label: 'Form F'
  }
];

export const particularOptions = [
  { label: 'Tuition Fee', value: 'Tuition Fee' },
  { label: 'Term Fee', value: 'Term Fee' },
  { label: 'Admission Fee', value: 'Admission Fee' },
  { label: 'Security Deposit', value: 'Security Deposit' },
  { label: 'Registration Fee', value: 'Registration Fee' },
  { label: 'Activity Fee', value: 'Activity Fee' },
  { label: 'Imprest', value: 'Imprest' },
  { label: 'Indian Board', value: 'Indian Board' },
  { label: 'International Board', value: 'International Board' },
  { label: 'Laboratory Fee', value: 'Laboratory Fee' },
  { label: 'Part A', value: 'Part A' },
  { label: 'Part B', value: 'Part B' }
];

export const paymentSchemeInstallmentHeader = [
  'Fee Period',
  'Particulars',
  'Amount',
  'Due Date',
  'Edit',
  'Delete'
];

export const admissionTypeTabs: {
  key: AdmissionType;
  label: string;
  IconActive: React.ElementType;
  IconInactive: React.ElementType;
}[] = [
  {
    key: 'rollover',
    label: 'Rollover',
    IconActive: Icons.RolloverOutlined,
    IconInactive: Icons.RolloverOutlinedBlack
  },
  {
    key: 'newAdmission',
    label: 'New Admission',
    IconActive: Icons.NewAdmissionOutlined,
    IconInactive: Icons.NewAdmissionOutlinedBlack
  }
];
